import { render, staticRenderFns } from "./SupplierLhtInvitation2.vue?vue&type=template&id=1f519fa8&scoped=true&"
import script from "./SupplierLhtInvitation2.vue?vue&type=script&lang=js&"
export * from "./SupplierLhtInvitation2.vue?vue&type=script&lang=js&"
import style0 from "./SupplierLhtInvitation2.vue?vue&type=style&index=0&id=1f519fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f519fa8",
  null
  
)

export default component.exports